/**
 * What the checkout charges (09.10.2026): the chosen cohort's own price when
 * it has one, else the site's. The server decides the amount; this only
 * shows the same number before the button is pressed.
 */
export function checkoutPrice(group, sitePrice) {
  const own = Number(group?.price);
  if (Number.isFinite(own) && own > 0) return own;
  return sitePrice ?? null;
}

/** "900 RON", or "" when there is no price to show. */
export function priceText(amount, currency = "RON") {
  return amount == null ? "" : `${Number(amount).toLocaleString("ro-RO")} ${currency}`;
}

/** The school a link cohort was made for: what the form shows locked. */
export function lockedSchool(linkGroup) {
  const name = String(linkGroup?.institution_name || "").trim();
  return linkGroup && linkGroup.access === "link" && name ? name : "";
}

/** Whether the checkout may mention the Prima de Carieră Didactică card
 *  (12.10.2026): yes, unless the chosen cohort has the card switched off. */
export function acceptsPrima(group) {
  return group?.prima_card !== false;
}
